import { render, staticRenderFns } from "./ViewAttorneyModal.vue?vue&type=template&id=46168b12"
import script from "./ViewAttorneyModal.vue?vue&type=script&lang=ts"
export * from "./ViewAttorneyModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports